<input class="no-validate" id="product-color-input" value="{{color}}" placeholder="#000000" (keyup)="updateColor($event.target)" [formControl]="colorGroup.controls['product_color']">

<div class="color-picked" [(colorPicker)]="color"
     [style.background]="color"
     [cpAlphaChannel]="'disabled'"
     [style.color]="color"
     [cpOutputFormat]="'hex'"
     (colorPickerChange)="onChangeColor($event);color=$event"></div>
